module.exports = __webpack_public_path__ + "img/lg_ring_g_o_1_1@3x.ebc5d724.png";